module.exports = __webpack_public_path__ + "img/HoF-ticketing-img@2x.e8499f46.png";